import { gql } from '@apollo/client';

export const GET_TEST_SESSION_NOTE = gql`
  query TestSessionNote($id: ID!) {
    testSessionNote(id: $id) {
      id
      createdAt
      createdBy {
        id
        profile {
          id
          firstName
        }
      }
      note
      noteRichText
      noteType
      shareCode
      shareEnabled
      status
      videoEndTime
      videoStartTime
      videoUrl
    }
  }
`;
